import React from "react";
import "./footer.scss";

export const CopyRight = () => {
  return <div className='copyRight'>© All Rights Reserved - SheKunj.Inc</div>;  
};
